import {gql} from "@apollo/client"

export default gql`
mutation UpdateProblem($problemId: ID!, $page_number:Int, $problem_type:String, $content:String, $status:String, $response:String) {
  updateProblem(problemId: $problemId, page_number:$page_number, problem_type:$problem_type, content:$content, status:$status, response:$response) {
    id
  }
}
`